import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-finance",
  "use": "icon-finance-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" class=\"icon\" id=\"icon-finance\">\r\n  <path id=\"icon-finance_财务\" class=\"cls-1\" d=\"M1035.5,617a8.5,8.5,0,1,1,8.49-8.5A8.51,8.51,0,0,1,1035.5,617Zm0-16.058a7.554,7.554,0,1,0,7.54,7.554A7.563,7.563,0,0,0,1035.5,600.946Zm3.02,6.775h-6.04a0.476,0.476,0,1,1,0-.951h6.04A0.476,0.476,0,0,1,1038.52,607.721Zm0,2.3h-6.04a0.476,0.476,0,1,1,0-.951h6.04A0.476,0.476,0,0,1,1038.52,610.025Zm-3.02,3.022a0.474,0.474,0,0,1-.48-0.475v-5.326a0.475,0.475,0,1,1,.95,0v5.326A0.472,0.472,0,0,1,1035.5,613.047Zm0.03-5.5a0.48,0.48,0,0,1-.34-0.139l-2.64-2.647a0.474,0.474,0,1,1,.67-0.672l2.64,2.647a0.467,0.467,0,0,1,0,.672A0.457,0.457,0,0,1,1035.53,607.55Zm0,0a0.48,0.48,0,0,1-.34-0.139,0.486,0.486,0,0,1,0-.672l2.65-2.647a0.472,0.472,0,0,1,.67,0,0.486,0.486,0,0,1,0,.672l-2.65,2.647A0.457,0.457,0,0,1,1035.53,607.55Z\" transform=\"translate(-1027 -600)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance.svg
// module id = pTuU
// module chunks = 127